import React from 'react';
import HeaderNews from './HeaderNews';
//import TopHead from './img/Swachhta2018.jpg';
class AssetsDownload extends React.Component {
	render() {
		return (

			<div>
				<HeaderNews />
				<div className="pages section">
					<div className="container">
						<div className="assetsdownload">
						<div className="assetsdownload-content">

<h6 className="heading-top">SWACHHTA PAKHWADA</h6>

<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Swachhta_Pledge.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_blank" href="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Swachhta_Pledge.pdf" download="">Read / Download the Swachhta Pledge in pdf file</a></li>


		</ul>
	</div>

</div>


<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Poster1.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_self" href="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Poster1.zip" download="">Download the Poster in Zip file</a></li>


		</ul>
	</div>

</div>


<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Backdrop.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_self" href="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Backdrop.zip" download="">Download the Backdrop in Zip file</a></li>


		</ul>
	</div>

</div>


<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Poster.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_self" href="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Poster.zip" download="">Download the Poster in Zip file</a></li>


		</ul>
	</div>

</div>



<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
	<div className="col">

		<img src="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Standee.jpg" alt="IndianOil Xpress" />

	</div>

	<div className="col">
		<ul class="cl_ul" >
			<li><a class="normallink" target="_self" href="https://iocl.com//uploads/ioclxpress/SwachhtaPakhwada/2020/Standee.zip" download="">Download the Standee in Zip file</a></li>


		</ul>
	</div>

</div>




</div>
							<br/>
							<div className="assetsdownload-content">

								<h6 className="heading-top">International Yoga Day</h6>


								<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
									<div className="col">

										<img src="http://iocl.com/uploads/ioclxpress/YogaDay/2020/Backdrop1.jpg" alt="IndianOil Xpress" />

									</div>

									<div className="col">
										<ul class="cl_ul" >
											<li><a class="normallink" target="_self" href="https://iocl.com/uploads/ioclxpress/YogaDay/2020/IOC_Hindi_English_Open_Curve_CDR%20_Backdrop_Option2.zip" download="">Download the Zip file</a></li>


										</ul>
									</div>

								</div>

							</div>




<br />
<div className="assetsdownload-content">

								<h6 className="heading-top">YEAR OF DIGITALISATION</h6>


								<div className="row" style={{ border: '1px solid', borderColor: '#d0cfce' }}>
									<div className="col">

										<img src="https://www.iocl.com/download/Backdrop_Revised_14x8.jpg" alt="IndianOil Xpress" />

									</div>

									<div className="col">
										<ul class="cl_ul" >
											<li><a class="normallink" target="_self" href="http://iocl.com//uploads/2020_Backdrop_and_Standee/download_all.zip" download="">Download the Zip file</a></li>


										</ul>
									</div>

								</div>

							</div>
							
						</div>
					</div>
				</div>



				<div className="footer bottom" style={{ position: 'relative' }}>
					<div className="container">
						<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br />
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
							<a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
							<a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
							<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
							<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>

						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default AssetsDownload;


// WEBPACK FOOTER //
// ./src/assetsDownload.js